import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import { appTheme } from 'components/AppTheme';
import { CSSProperties } from 'react';
import { EdwardColors } from 'enums';

// key theme customizations

export default makeStyles((theme: Theme) =>
  createStyles({

    toolbar: {
      display: 'flex',
      alignItems: 'center',
    },
    originalToolbar: {
      flex: '1',
      '& > div > div': {
        '&:nth-child(2)': { display: 'none' },
      },
    },
    buttons: {
      textAlign: 'right',
      '& > *': {
        margin: theme.spacing(2, 1),
      },
    },

    status: {
      color: EdwardColors.WARNING,
      '&.status_ACTIVE': {
        color: appTheme.palette.success.main,
      },
      '&.status_CANCELLED': {
        color: appTheme.palette.grey['500'],
      },
    },
    loadingContainer: {
      width: '100%',
      height: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    loadingLine: {
      width: '100%',
      height: '10vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    loadingWrapper: {
      position: 'relative',
      marginTop: theme.spacing(2),
    },
    loadingOverlay: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(255,255,255,0.8)',
      position: 'absolute',
      left: 0,
      top: 0
    },
    severity: {
      display: 'inline-flex',
      alignItems: 'center',
      '& svg': {
        marginRight: theme.spacing(0.5),
      },
      '&.severity_CLOSE': { color: EdwardColors.WARNING, fontWeight: 'bold' },
      '&.severity_DUE': { color: EdwardColors.ALERT, fontWeight: 'bold' },
      '&.severity_OVERDUE': { color: EdwardColors.ALERT, fontWeight: 'bold' },
    },
    profit: {
      '&.negative_false': { color: EdwardColors.POSITIVE },
      '&.negative_true': { color: EdwardColors.NEGATIVE },
    },
    balance: {
      '&.negative_false': { color: EdwardColors.POSITIVE },
      '&.negative_true': { color: EdwardColors.ALERT },
    },
    noWrap: {
      whiteSpace: 'nowrap',
    },
    accountsCollapsed: {
      background: '#eee',
      paddingTop: 0,
      paddingBottom: 0,
    },
    accountsOpen: {
      background: '#eee',
      paddingTop: 0,
      paddingBottom: 0,
      borderTop: 'solid 1px #666',
      borderBottom: 'solid 1px #666',
    },
    advisorRow: {
      '&:hover': { background: theme.palette.grey[100], cursor: 'pointer' },
    },
    name: {
      fontSize: '19px',
      '@media (max-width:400px)': {
        fontSize: '14px',
      }
    },
    secondLine: {
      color: theme.palette.grey['700'],
      display: 'block',
      '@media (max-width:400px)': {
        fontSize: '14px',
      },
    },
    footer: {
      '& td': {
        background: '#f5f5f5',
        padding: theme.spacing(2,5,2,2),
        borderBottom: 'solid #ccc 1px'
      }
    }
  }),
);

export const paddingRight = '40px';

export const rightCellStyles = {
  textAlign: 'right',
  paddingRight,
} as CSSProperties;

export const centerCellStyles = {
  textAlign: 'center',
  paddingRight,
} as CSSProperties;
